import React from 'react';
import { Button } from '../ui/button';
import { X } from 'lucide-react';
import { formatarHoras } from '../../utils/formatarHoras';

/**
 * Modal para visualizar o histórico de banco de horas de um colaborador
 */
const HorarioHistoricoBancoModal = ({
  show,
  loading,
  historicoData,
  onClose,
  onExportar
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-6 border-b border-border flex items-center justify-between">
          <h2 className="text-xl font-semibold flex items-center gap-2">
            💰 Histórico de Banco de Horas
          </h2>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClose}
          >
            <X className="h-5 w-5" />
          </Button>
        </div>
        
        <div className="p-6 overflow-y-auto flex-1">
          {loading ? (
            <div className="flex items-center justify-center py-8">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
          ) : historicoData ? (
            <div>
              <div className="mb-4">
                <h3 className="text-lg font-semibold">{historicoData.colaborador_nome}</h3>
                <p className="text-sm text-gray-600">
                  Total de períodos: {historicoData.total_periodos}
                </p>
              </div>
              
              {historicoData.historico && historicoData.historico.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse">
                    <thead>
                      <tr className="bg-gray-100 border-b-2 border-gray-300">
                        <th className="p-2 text-left text-xs font-semibold">Período</th>
                        <th className="p-2 text-right text-xs font-semibold">Banco H Anterior</th>
                        <th className="p-2 text-right text-xs font-semibold">Banco H Período</th>
                        <th className="p-2 text-right text-xs font-semibold">Banco H Total</th>
                        <th className="p-2 text-right text-xs font-semibold">Horas Trab.</th>
                        <th className="p-2 text-center text-xs font-semibold">Dias</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historicoData.historico.map((periodo, idx) => (
                        <tr key={idx} className={`border-b ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                          <td className="p-2 text-xs">{periodo.periodo}</td>
                          <td className="p-2 text-right text-xs text-orange-600 font-semibold">
                            {formatarHoras(periodo.banco_horas_anterior?.toFixed(2) || 0)}
                          </td>
                          <td className="p-2 text-right text-xs">
                            {formatarHoras(periodo.banco_horas_periodo?.toFixed(2) || 0)}
                          </td>
                          <td className={`p-2 text-right text-xs font-bold ${
                            (periodo.banco_horas_total || 0) >= 0 ? 'text-green-600' : 'text-red-600'
                          }`}>
                            {formatarHoras(periodo.banco_horas_total?.toFixed(2) || 0)}
                          </td>
                          <td className="p-2 text-right text-xs">
                            {formatarHoras(periodo.total_horas_trabalhadas?.toFixed(2) || 0)}
                          </td>
                          <td className="p-2 text-center text-xs">
                            {periodo.dias_ferias > 0 && <span className="text-green-600" title="Férias">✈️{periodo.dias_ferias} </span>}
                            {periodo.dias_falta > 0 && <span className="text-red-600" title="Faltas">❌{periodo.dias_falta} </span>}
                            {periodo.dias_folga > 0 && <span className="text-orange-600" title="Folgas">⚠️{periodo.dias_folga}</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500">
                  Nenhum histórico encontrado
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-8 text-gray-500">
              Erro ao carregar histórico
            </div>
          )}
        </div>
        
        <div className="p-6 border-t border-border flex justify-end gap-2">
          <Button 
            variant="outline" 
            onClick={onClose}
          >
            Fechar
          </Button>
          {historicoData && (
            <Button 
              onClick={() => onExportar(historicoData.colaborador_id)}
              className="bg-green-600 hover:bg-green-700"
            >
              📊 Exportar Excel
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default HorarioHistoricoBancoModal;
